/* eslint-disable import/prefer-default-export */
import { PropTypes } from 'react';

export const imageInfoShape = PropTypes.shape({
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  orientation: PropTypes.oneOf(['landscape', 'portrait', 'square']).isRequired,
  src: PropTypes.string.isRequired,
});

export const workShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  dimensions: PropTypes.string.isRequired,
  medium: PropTypes.string.isRequired,
  statement: PropTypes.string,
  images: PropTypes.arrayOf(imageInfoShape).isRequired,
  type: PropTypes.string,
});

export const seriesShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  works: PropTypes.arrayOf(PropTypes.string).isRequired,
  statement: PropTypes.string,
});



// WEBPACK FOOTER //
// ./application/js/lib/shapes.js